import React, { Fragment } from 'react';
import cn from 'classnames';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Icon from '../../../../Icon';
import RequiredAdditionalInsuranceDataError from '../RequiredAdditionalInsuranceDataError';
import { COLORS } from '../../../../../constants/styles';
import { SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES } from '../../../../../constants/insurance-flow-type';

import styles from './index.styl';

const ICON_STYLES = { fill: COLORS.bluePrimary };

const AdditionalInsuranceCollapse = ({
  children,
  flowType,
  onClick,
  opened,
  showError,
}) => {
  const { formatMessage } = useIntl();

  const withAdditionalStyles = SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES.includes(
    flowType,
  );

  const title = formatMessage({ id: 'profile.insurance.additional' });

  return (
    <Fragment>
      <button
        type="button"
        onClick={onClick}
        className={cn(styles.section, {
          [styles.section_opened]: opened,
          [styles.section_additionalStyles]: withAdditionalStyles,
        })}
      >
        {title}
        <div className={styles.endSection}>
          {showError && <RequiredAdditionalInsuranceDataError />}
          <Icon
            size={12}
            name="arrow-down-forms"
            className={cn({ [styles.icon]: opened })}
            style={ICON_STYLES}
          />
        </div>
      </button>
      {opened && <div>{children}</div>}
      {withAdditionalStyles && <div className={styles.divider} />}
    </Fragment>
  );
};

AdditionalInsuranceCollapse.propTypes = {
  children: PropTypes.node,
  flowType: PropTypes.string,
  onClick: PropTypes.func,
  opened: PropTypes.bool,
  showError: PropTypes.bool,
};

export default AdditionalInsuranceCollapse;



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/AdditionalInsuranceCollapse/index.jsx